import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import { getProcedureTypes } from "../../crud/auth.crud";
import {
  Portlet,
  PortletBody,
//  PortletHeader,
//  PortletHeaderToolbar
} from "../../partials/content/Portlet";
import QuickStatsChart from "../../widgets/QuickStatsChart";
import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import EditIcon from '@material-ui/icons/Edit';
 import { Link } from "react-router-dom";

export default class Account extends React.Component {
  state = {
    procedureTypes:[],
    
  }

  
  componentDidMount()
  {
    
    
    getProcedureTypes().then(response => response.data)
    .then((data) => {
       
      this.setState({ procedureTypes: data })
      //console.log(this.state.users)
     })
  
    
  }
  render() {
    return (
      <>

        

        <div className="row">
          <div className="col-md-12">
            <Grid beforeCodeTitle="Procedure Types" jsCode="true" createPath="/createprocedure">
              <div className="kt-section">
               
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      
                      <th>Procedure Type</th>
                      <th>Description</th>
                      <th>Edit</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.procedureTypes.map((type) => (
                    <tr>
                     
                      <td>{type.procedureTypeName}</td>
                      <td>{type.typeDescription}</td>
                    
                      <td>
                         
                          <Link  to={{pathname:"/editprocedure", data: {procedureType:type}}}>
                           <Tooltip
                                    title="Edit Procedure Type" 

                                  >
                            <IconButton>
                              <EditIcon style={{ color: '#5578eb',fontSize: 12}}/>   
                            </IconButton>
                            </Tooltip>
                          </Link>
                          
                      </td>
                    </tr>
                    ))}
                </tbody>
                </Table>
              </div>
            </Grid>
          </div>
         
        </div>

      

       
      </>
    );
  }
}
